import { useState } from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { SpinnerLoading } from "@/main/components/shared/styles";
import { procurementHistoricalapi } from "@/main/api";
import { ProcurementHistoricalDetailsResponse } from "@/main/models/response";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import DetailsSupplierParts from "./detailsSupplierParts/detailsSupplierParts";
import * as S from "./styles";
import { ProcurementHistoricalActionEnum } from "@/main/services/enum/ProcurementHistoricalActionEnum";

export interface IDetailsHistoryProps {
	id?: string;
	title: string;
	guidProcurementHistorical: string;
	date: string;
	hours: string;
	userName: string;
	showPrices: boolean;
	idAction: number;
}

function DetailsHistory({
	title,
	guidProcurementHistorical,
	date,
	hours,
	userName,
	showPrices,
	idAction,
}: IDetailsHistoryProps) {
	const [isLoading, setIsLoading] = useState(false);
	const [dataDetailsHistory, setDataDetailsHistory] = useState<ProcurementHistoricalDetailsResponse[]>([]);
	function fetchDetailsHistory() {
		if (dataDetailsHistory.length > 0 || isLoading) return;
		setIsLoading(true);
		procurementHistoricalapi
			.getDetails({
				guidHistorical: guidProcurementHistorical,
			})
			.then((response) => {
				const { result } = response.data;
				setDataDetailsHistory(result);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}

	const historyHasDetail = (idHistoricalAction: number) => {
		const idsActionWithDetail: number[] = [
			ProcurementHistoricalActionEnum.CartChekout,
			ProcurementHistoricalActionEnum.JobChekout,
			ProcurementHistoricalActionEnum.CartChekoutTotalLoss,
			ProcurementHistoricalActionEnum.PartStatusChanged,
			ProcurementHistoricalActionEnum.OrderStatusChanged,
			ProcurementHistoricalActionEnum.ReassignedOrder,
			ProcurementHistoricalActionEnum.SubOrderStatusChanged,
			ProcurementHistoricalActionEnum.PartStatusChangedReassing,
			ProcurementHistoricalActionEnum.EditedOrderPrice,
			ProcurementHistoricalActionEnum.InvoiceEdited,
			ProcurementHistoricalActionEnum.ShippingCostsChanged,
			ProcurementHistoricalActionEnum.DeliveryDateUpdated,
			ProcurementHistoricalActionEnum.PaymentVoucher,
			ProcurementHistoricalActionEnum.MarkedForLaterCancel,
		];
		return idsActionWithDetail.includes(idHistoricalAction);
	};

	return historyHasDetail(idAction) ? (
		<S.AccordionHistory
			onChange={(e, expanded) => {
				if (expanded && dataDetailsHistory.length === 0) {
					fetchDetailsHistory();
				}
			}}
		>
			<S.AccordionSummaryHistory
				id="id-modalHistory-accordion-detailshistory"
				aria-controls="categories-content"
				expandIcon={<ExpandMore fontSize="medium" />}
			>
				<S.AccordionTitle>
					<span>{title}</span>
					{date && ` - ${date}`}
					{hours && ` - ${hours}`}
					{userName && ` - ${userName}`}
				</S.AccordionTitle>
			</S.AccordionSummaryHistory>
			<S.AccordionDetailsHistory>
				{isLoading ? (
					<SpinnerLoading />
				) : dataDetailsHistory.length === 0 ? (
					<ResultNotFoundComponent />
				) : (
					dataDetailsHistory.map((item, index) => (
						<DetailsSupplierParts key={item.supplierName || index} showPrices={showPrices} {...item} />
					))
				)}
			</S.AccordionDetailsHistory>
		</S.AccordionHistory>
	) : (
		<S.AccordionHistoryWithoutDetail>
			<span>{title}</span>
			{date && ` - ${date}`}
			{hours && ` - ${hours}`}
			{userName && ` - ${userName}`}
		</S.AccordionHistoryWithoutDetail>
	);
}

export default DetailsHistory;
